import styled from 'styled-components';
import { Colors } from 'core/CssVariables';
import Divider from 'components/Base/Divider';

export const SDivider = styled(Divider)`
  .ant-divider-inner-text {
    line-height: 16px;
    color: ${Colors.LightGrey};
  }
`;
